// TrackLeadSource.jsx
import { useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';

export default function TrackLeadSource() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const utm_source = params.get('utm_source') || 'orgânico';
    const utm_medium = params.get('utm_medium') || '';
    const utm_campaign = params.get('utm_campaign') || '';
    const referrer = document.referrer || 'direto';

    const leadData = { source: utm_source, medium: utm_medium, campaign: utm_campaign, referrer };

    ReactPixel.trackCustom('LeadSource', leadData);
  }, []);

  return null; // componente não renderiza nada visualmente
}
